import { CircularProgress } from '@material-ui/core';

const CircularIndicator = CircularProgress;

export default CircularIndicator;
